const URL_PATTERN = /^https?:\/\/[^\s]+\.[^\s]+$/;
const WEBHOOK_MAX_LENGTH = 255;

export const validateWebhookUrl = (value, $t) => {
    const url = value || "";

    if (!url.trim()) return "";
    if (url.length > WEBHOOK_MAX_LENGTH)
        return $t("validation.max", { length: WEBHOOK_MAX_LENGTH });
    if (!URL_PATTERN.test(url.trim())) return $t("dialog.webhooks.url");

    return "";
};

const SIP_NAME_MAX_LENGTH = 40;
const SIP_PASSWORD_MIN_LENGTH = 6;
const SIP_PASSWORD_MAX_LENGTH = 64;

export const validateSipName = (value, $t) => {
    const name = value || "";

    if (!name.trim()) return "";
    if (name[0] === " ") return $t("validation.no_leading_space");
    if (name.length > SIP_NAME_MAX_LENGTH)
        return $t("validation.max", { length: SIP_NAME_MAX_LENGTH });

    return "";
};

export const validateSipPassword = (value, $t) => {
    const password = value || "";

    if (!password) return "";
    if (password.length < SIP_PASSWORD_MIN_LENGTH)
        return $t("validation.min", { length: SIP_PASSWORD_MIN_LENGTH });
    if (password.length > SIP_PASSWORD_MAX_LENGTH)
        return $t("validation.max", { length: SIP_PASSWORD_MAX_LENGTH });

    return "";
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
// 8 digits of a company's EDRPOU or 10 of a sole trader's tax number;
// CreateInvoiceRequest on the backend takes 8 to 10
const EDRPOU_MIN_LENGTH = 8;
const EDRPOU_MAX_LENGTH = 10;

export const validateEmail = (value, $t) => {
    const email = value || "";

    if (!email.trim()) return "";
    if (!EMAIL_PATTERN.test(email.trim())) return $t("validation.invalid_email");

    return "";
};

export const validateEdrpou = (value, $t) => {
    const code = value || "";

    if (!code.trim()) return "";
    if (!/^[0-9]*$/.test(code)) return $t("validation.digits");
    if (code.length < EDRPOU_MIN_LENGTH)
        return $t("validation.min", { length: EDRPOU_MIN_LENGTH });
    if (code.length > EDRPOU_MAX_LENGTH)
        return $t("validation.max", { length: EDRPOU_MAX_LENGTH });

    return "";
};
